import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { EditIcon, CloseIcon, ExitToAppIcon } from './../../../themes/icons';
import { Typography } from './../../../themes/default';
import { Loading } from './../../../components/includes/loading';
import { Section, Content, Main, Buttons, FormActions } from './../../../components/includes/container';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Table, Thead, Tbody, Row, Cell, Tresponsive, Tpagination, Ttolbar } from './../../../components/includes/ui/table';
import { Modal } from './../../../components/includes/modal';
import { Btn, Label } from './../../../components/includes/ui';
import { FormatDate } from './../../../utilities/date';
import { isUndefined, isSorting, isStatus, parseQueryString } from './../../../utilities/utils';
import { PageContentService } from './../../../services';
import Confirm from './../../shared/confirm';
import PageContentFilter from './../filter';

import API from './../../../config/api';

const rows = [
  { id: 'title', sort: false, numeric: false, disablePadding: false, label: 'Título' },
  { id: 'status', sort: false, numeric: false, disablePadding: false, label: 'Estado' },
  { id: 'created_at', sort: false, numeric: false, disablePadding: false, label: 'Creado' },
  { id: 'updated_at', sort: false, numeric: false, disablePadding: false, label: 'Editado' },
  { id: 'actions', sort: false, numeric: true, disablePadding: false, label: 'Acciones', width:160, minWidth: 160 }
];

class PageContent extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      page: 0,
      order: 'asc',
      orderBy: 'name',
      entities: null,
      formDeleteShow: false,
      formDeleteMessage: null,
      formCodeShow: false,
      formCodeValue: undefined,
      formFilterShow: false,
      categories: ['asistencia', 'cobertura', 'promocion', 'tyc'],
      categoriesSlug: ['asistencias', 'coberturas', 'promociones', 'terminos-y-condiciones'],
    };
  }

  componentDidMount(){

    // @Pagination
    let page = this.props.match.params.page;

    if(!isUndefined(page)){

      if(!isNaN(page) && page >= 0){

        this._Find(page);

      }else{

        this.props.history.push('/page-content');

      }

    }else{

      this._Find(this.state.page);

    }

  }

  componentDidUpdate(next_props){
    if(next_props.match.params.page !== this.props.match.params.page){
      this._Find(this.props.match.params.page);
    }

    if(next_props.location.search !== this.props.location.search){
      this._Find(this.props.match.params.page || 0, parseQueryString(this.props.location.search));
    }
  }

  /*
  ** @Service
  ** @Description: FindAll
  */

  _Find = (page) => {

    PageContentService.get(page, parseQueryString(this.props.location.search)).then((response) => {

      this.setState({ loading: true, page: !isUndefined(page) ? parseInt(page,10) : 0, entities: response });

    }).catch((error) => {

      this.props.AlertShow({ open: true, variant: 'error', message: Error.internal });

    });

  }

  /*
  ** @Service
  ** @Description: Delete
  */

  _Delete = (id) => {

    PageContentService.remove(id).then((response) => {

      // @State
      this.setState({ formDeleteShow: false });

      // @Service find all by page
      this._Find(this.props.match.params.page);

      // @Dispatch alert success
      this.props.AlertShow({ open: true, variant: 'success', message: `Exito, la página fue eliminada.` });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: Error.internal });

    });

  }

  /*
  ** @Event
  ** @Description: Delete user
  */

  handleDelete = (id, name) => {
    this.setState({
      id: id,
      formDeleteShow: true,
      formDeleteMessage: `¿Confirma la eliminación de ${ name }?`
    });
  }

  /*
  ** @Click
  ** @Description: Delete user
  */

  handleConfirmDeleteConfirm = () => {
    this._Delete(this.state.id);
  }

  /*
  ** @Click
  ** @Description: Cancel delete user
  */

  handleConfirmDeleteCancel = () => {
    this.setState({ formDeleteShow: false });
  }

  /*
  ** @Click
  ** @Description: Cancel filter
  */
  handleOpenFilterShow = () => {
    this.setState({ formFilterShow: true });
  };

  /*
  ** @Click
  ** @Description: Cancel filter
  */
  handleCancelFilterShow = () => {
    this.setState({ formFilterShow: false });
  };

  /*
  ** @Handle
  ** @Description: Change page
  */

  handleChangePage = (event, page) => {
    this.setState({ page });
    this.props.history.push({
      pathname: `/page-content/page/${ page }`,
      search: this.props.location.search
    });
  };

  handleCategorySlug = (value) => {
    return this.state.categories.findIndex(c => c === value);
  }

  render() {

    const { loading, order, orderBy, entities, formCodeShow, formCodeValue, formFilterShow } = this.state;

    return (
      <Section>

        <ToolbarPrimary title="Páginas"/>
        <BreadcrumbItem to='/page-content'>Páginas</BreadcrumbItem>

        <Content>
          <Main>

            <Confirm
               status={ this.state.formDeleteShow }
               message={ this.state.formDeleteMessage }
               cancel={ () => { this.handleConfirmDeleteCancel() } }
               confirm={ () => { this.handleConfirmDeleteConfirm() } }
            />

            <Modal
              status={formFilterShow}
              title="Filtrar"
              handleCancel={this.handleCancelFilterShow}
              maxWidth="sm"
            >
              <PageContentFilter onSuccess={ this.handleCancelFilterShow }/>
            </Modal>

            <Modal
              status={formCodeShow}
              title="Código"
              handleCancel={this.handleCancelCodeShow}
              maxWidth="sm">
                <Typography align="center" gutterBottom>Copiar el siguiente código y pegar en la sección correspondiente</Typography>
                <code style={{display:'block',textAlign:'center'}}>
                  {formCodeValue}
                </code>
            </Modal>

            <Ttolbar title="Páginas">
              <Buttons>
                {this.props.location.search !== '' && (
                  <Btn
                    icon="remove"
                    size="medium"
                    color="danger"
                    title="Eliminar filtros"
                    component={NavLink}
                    to="/page-content"
                  />
                )}
                <Btn color="info" aria-label="add" icon="filter" onClick={this.handleOpenFilterShow}>
                  Filtrar
                </Btn>
                <Btn color="success" aria-label="add" icon="add" component={ NavLink } to="/page-content/create">
                  Crear página
                </Btn>
              </Buttons>
            </Ttolbar>

            { loading ? (

              <div>

                <Tresponsive enabledActions>
                  <Table>

                    <Thead rows={ rows } order={ order } orderBy={ orderBy } onRequestSort={ this.handleRequestSort }/>

                    <Tbody>

                      { entities.pages.length > 0 ? (

                        entities.pages.sort(isSorting(order, orderBy)).map(entity => {
                          return (
                            <Row key={ entity._id }>
                              <Cell>{ entity.title }</Cell>
                              <Cell>
                                <Label variant={ entity.status ? "success" : "danger"}>
                                  { isStatus(entity.status) }
                                </Label>
                              </Cell>
                              <Cell>
                                <FormatDate value={ entity.created_at }/>
                              </Cell>
                              <Cell>
                                <FormatDate value={ entity.updated_at }/>
                              </Cell>
                              <Cell numeric>
                                <Btn color="info" size="xsmall" href={`${ API.endpoint.web }/${ this.state.categoriesSlug[this.handleCategorySlug(entity.category)] }/${ entity.slug }`} target="_blank">
                                  <ExitToAppIcon fontSize="small"/>
                                </Btn>
                                <Btn color="danger" size="xsmall" onClick={ () => { this.handleDelete(entity._id, `${ entity.title }`) } }>
                                  <CloseIcon fontSize="small"/>
                                </Btn>
                                <Btn color="primary" size="xsmall" component={ NavLink } to={ `/page-content/update/${ entity._id }` }>
                                  <EditIcon fontSize="small"/>
                                </Btn>
                              </Cell>
                            </Row>
                          );
                        })

                      ) : (

                        <Row key="1">
                          <Cell colSpan={ rows.length }>No se encontraron resultados.</Cell>
                        </Row>

                      )}

                    </Tbody>
                  </Table>
                </Tresponsive>

                { entities.pages.length > 0 && (
                  <FormActions disablePadding>
                    <Tpagination count={ entities.total } page={ this.state.page } onChangePage={ this.handleChangePage } />
                  </FormActions>
                )}

              </div>
            ) : (
              <Loading variant="primary"/>
            ) }

          </Main>
        </Content>
      </Section>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PageContent);
